import React from 'react'
import get from 'lodash/get'
import _ from 'lodash'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'

import SitePost from '../components/SitePost'
import SiteEvent from '../components/SiteEvent'
import { connect } from 'react-redux'
import moment from 'moment'

class Index extends React.Component {
  render() {
    const site = get(this, 'props.data.site.siteMetadata')
    const posts = get(this, 'props.data.remark.posts')
    const { now, browser } = this.props

    console.log('browser', browser, now)

    const pageLinks = []
    _(posts)
      .filter(p => get(p, 'post.frontmatter.layout') === 'post')
      .sortBy(p => get(p, 'post.frontmatter.date'))
      .reverse()
      .forEach((data, i) => {
        const path = get(data, 'post.path')
        if (path !== '/404/') {
          pageLinks.push(
            <SitePost data={data.post} site={site} isIndex={true} key={i} />
          )
        }
      })

    const eventLinks = []
    _(posts)
      .filter(p => get(p, 'post.frontmatter.layout') === 'event')
      .filter(p => {
        const when = get(p, 'post.frontmatter.when')
        const whenMoment = moment(when)
        console.log('when', whenMoment, when)
        return (
          now === null ||
          !whenMoment.isBefore(moment(now).subtract({ days: 7 }))
        )
      })
      .sortBy(p => get(p, 'post.frontmatter.when'))
      .forEach((data, i) => {
        const path = get(data, 'post.path')
        if (path !== '/404/') {
          eventLinks.push(
            <SiteEvent
              data={data.post}
              when={data.when}
              where={data.where}
              site={site}
              isIndex={true}
              key={i}
            />
          )
        }
      })

    return (
      <div>
        <Helmet
          title={get(site, 'title')}
          meta={[
            { property: 'og:title', content: get(site, 'title') },
            { property: 'og:type', content: 'website' },
            { property: 'og:description', content: get(site, 'description') },
            { property: 'og:url', content: get(site, 'url') },
            {
              property: 'og:image',
              content: `${get(site, 'url')}/img/profile.jpg`,
            },
          ]}
        />
        <div className="container">
          <div className="row">
            <div className="col">
              <section>
                <div className="container">
                  <p className="lead mb-4">
                    Siljekvarnsvägens samfällighetsförenings hemsida.
                  </p>
                  <h3>Sammanträden och träffar</h3>
                  <ul className="list-group mb-4">{eventLinks}</ul>
                  <h3>Senaste nyheter</h3>
                  {pageLinks}
                </div>
              </section>
            </div>
            <div className="col-4">
              <section>
                <div className="card mb-4">
                  <h5 className="card-header">Kontakta styrelsen</h5>
                  <div className="card-body">
                    <table className="table table-sm table-borderless pb-0 mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">Epost</th>
                          <td>...</td>
                        </tr>
                        <tr>
                          <th scope="row">Telefon</th>
                          <td>...</td>
                        </tr>
                        <tr>
                          <th scope="row" colSpan="2">
                            <a href="#" className="">
                              Använd formulär
                            </a>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="card mb-4">
                  <h5 className="card-header">Interninfo</h5>
                  <div className="card-body">
                    <p className="card-text">
                      Intern information för de boende.
                    </p>
                    <Link to="/inloggning" className="btn btn-secondary">
                      Till inloggning
                    </Link>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ now, browser }) => {
  return { now, browser }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        description
        url: siteUrl
        author
      }
    }
    remark: allMarkdownRemark {
      posts: edges {
        post: node {
          html
          frontmatter {
            layout
            title
            path
            categories
            when
            where
            date(formatString: "YYYY/MM/DD")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js